import cx from "classnames";
import { useState } from "react";

import { CopyOutlined } from "@ant-design/icons";
import { ConfigProvider, Tabs } from 'antd';
import { useTranslation } from "react-i18next";

import { EMPLOYEE_SALARY_PAGE } from "../schemas/employeeSalarySchema";
import styles from "../styles/Employee.module.css";
import menuStyles from "../styles/EmployeeMenu.module.css";
import EmployeeSalaryAbsenceDeduct from "../pages/EmployeeSalaryAbsenceDeduct";
import EmployeeSalaryAccumulate from "../pages/EmployeeSalaryAccumulate";
import EmployeeSalaryAllowance from "../pages/EmployeeSalaryAllowance";
import EmployeeSalaryBonus from "../pages/EmployeeSalaryBonus";
import EmployeeSalaryIncomDeduction from "../pages/EmployeeSalaryIncomDeduction";
import EmployeeSalaryLateEarltDeduct from "../pages/EmployeeSalaryLateEarlyDeduct";
import EmployeeSalaryLiabilities from "../pages/EmployeeSalaryLiabilities";
import EmployeeSalaryOvertime from "../pages/EmployeeSalaryOvertime";
import EmployeeSalarySalary from "../pages/EmployeeSalarySalary";
import EmployeeSalarySocialSecurity from "../pages/EmployeeSalarySocialSecurity";
import EmployeeSalaryTax from "../pages/EmployeeSalaryTax";
import { useSelector } from "react-redux";
function getItem(i18n_key, label, key, icon, children, type) {
  return {
    i18n_key,
    key,
    icon,
    children,
    label,
    type,
  };
}

const EMPLOYEE_WORKIN_MENU = [
  getItem(
    EMPLOYEE_SALARY_PAGE.SALARY,
    "Salary",
    EMPLOYEE_SALARY_PAGE.SALARY,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.BONUS,
    "Bonus",
    EMPLOYEE_SALARY_PAGE.BONUS,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.INCOME_DEDUCTION,
    "Income/Deduction",
    EMPLOYEE_SALARY_PAGE.INCOME_DEDUCTION,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.OVERTIME,
    "Overtime",
    EMPLOYEE_SALARY_PAGE.OVERTIME,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.ABSENCE_DEDUCT,
    "Absencee Deduct",
    EMPLOYEE_SALARY_PAGE.ABSENCE_DEDUCT,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.LATE_EARLY_DEDUCT,
    "Late/Early Deduct",
    EMPLOYEE_SALARY_PAGE.LATE_EARLY_DEDUCT,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.ACCUMULATE,
    "Accumulate",
    EMPLOYEE_SALARY_PAGE.ACCUMULATE,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.LIABILITIES,
    "Liabilities",
    EMPLOYEE_SALARY_PAGE.LIABILITIES,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.ALLOWANCE,
    "Allowance",
    EMPLOYEE_SALARY_PAGE.ALLOWANCE,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.TAX,
    "Tax",
    EMPLOYEE_SALARY_PAGE.TAX,
    <CopyOutlined />
  ),
  getItem(
    EMPLOYEE_SALARY_PAGE.SOCIAL_SECURITY,
    "Social Security",
    EMPLOYEE_SALARY_PAGE.SOCIAL_SECURITY,
    <CopyOutlined />
  ),
];

function EmployeeSalaryMenu({ className = "", onChange = () => { } }) {
  const [selectedKeys, setSelectedKeys] = useState([
    EMPLOYEE_SALARY_PAGE.SALARY,
  ]);


  const { t } = useTranslation();
  const { roles } = useSelector((state) => state.company);
  const onMenuClick = (e) => {
    const key = e.key;
    setSelectedKeys([key]);
    onChange(key);
  };

  return (
    <div>
      <ConfigProvider
        theme={{
          components: {
            Tabs: {
              itemHoverColor: "var(--tab-color)",
              itemActiveColor: "var(--tab-color)"
            },
          },
        }}
      >
        <Tabs destroyInactiveTabPane={true} defaultActiveKey={selectedKeys} onChange={onMenuClick} tabBarStyle={{ justifyContent: 'space-between' }}>
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|SALARY") &&
            <Tabs.TabPane tab={t('salary.salary')} key={EMPLOYEE_SALARY_PAGE.SALARY}>
              <EmployeeSalarySalary />
            </Tabs.TabPane>
          }
          {/* {
          roles.includes("ACCESS_EMPLOYEE|SALARY|BONUS") &&
          <Tabs.TabPane tab={t('salary.bonus')} key={[EMPLOYEE_SALARY_PAGE.BONUS]} >
            <EmployeeSalaryBonus />
          </Tabs.TabPane>
        } */}
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|INCOME_DEDUCTION") &&
            <Tabs.TabPane tab={t('salary.income-deduction')} key={[EMPLOYEE_SALARY_PAGE.INCOME_DEDUCTION]} >
              <EmployeeSalaryIncomDeduction />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|OVERTIME") &&
            <Tabs.TabPane tab={t('income.label.overtime')} key={[EMPLOYEE_SALARY_PAGE.OVERTIME]} >
              <EmployeeSalaryOvertime />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|ABSENCEE_DEDUCT") &&
            <Tabs.TabPane tab={t('salary.absencee-deduct')} key={[EMPLOYEE_SALARY_PAGE.ABSENCE_DEDUCT]} >
              <EmployeeSalaryAbsenceDeduct />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|LATE_EARLY_DEDUCT") &&
            <Tabs.TabPane tab={t('salary.late-early-deduct')} key={[EMPLOYEE_SALARY_PAGE.LATE_EARLY_DEDUCT]} >
              <EmployeeSalaryLateEarltDeduct />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|ACCUMULATE") &&
            <Tabs.TabPane tab={t('saraly.accumulate')} key={EMPLOYEE_SALARY_PAGE.ACCUMULATE}>
              <EmployeeSalaryAccumulate />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|LIABILITIES") &&
            <Tabs.TabPane tab={t('liabilities.header')} key={[EMPLOYEE_SALARY_PAGE.LIABILITIES]} >
              <EmployeeSalaryLiabilities />
            </Tabs.TabPane>
          }
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|ALLOWANCE") &&
            <Tabs.TabPane tab={t('salary.deduction')} key={[EMPLOYEE_SALARY_PAGE.ALLOWANCE]} >
              <EmployeeSalaryAllowance />
            </Tabs.TabPane>
          }
          {/* {
            roles.includes("ACCESS_EMPLOYEE|SALARY|TAX") &&
            <Tabs.TabPane tab={t('salary.tax')} key={[EMPLOYEE_SALARY_PAGE.TAX]} >
              <EmployeeSalaryTax />
            </Tabs.TabPane>
          } */}
          {
            roles.includes("ACCESS_EMPLOYEE|SALARY|SOCIAL_SECURITY") &&
            <Tabs.TabPane tab={t('salary.social-security')} key={[EMPLOYEE_SALARY_PAGE.SOCIAL_SECURITY]} >
              <EmployeeSalarySocialSecurity />
            </Tabs.TabPane>
          }


        </Tabs>
      </ConfigProvider>

    </div>
  );
}

export default EmployeeSalaryMenu;
